import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_condicionfacturacion_id: new EntityColumn<string>({ name: 'c_condicionfacturacion_id', type: 'char', length: 20, flags: c.PK, prompt: 'Condición de facturacion ID' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        i_dias: new EntityColumn<number>({ name: 'i_dias', type: 'int', flags: c.Edit, prompt: 'Días' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        cdfc_brwStandard: { name: 'cdfc_brwStandard', keyMappings: { c_condicionfacturacion_id: 0 } }
    }
)

export class CondicionesFacturacionDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('CondicionesFacturacion');
    }
}